import { useSyncCountry } from "@App/hooks/useSyncCountry";
import { useOrganizationConfig } from "@App/hooks/whitelabel/home/useOrganizationConfig";
import { DefaultPartnerLayout } from "@App/Layouts/Partner/DefaultPartnerLayout";
import { DefaultRoutes } from "@App/routes/Partner/DefaultRoutes";
import { Home } from "./Home";

export function Mahle() {
  const { config } = useOrganizationConfig();

  useSyncCountry();

  return (
    <DefaultRoutes
      layout={
        <DefaultPartnerLayout
          logos={config.navbar.logos}
          backToPartnerButton={config.navbar.backToPartnerButton}
        />
      }
      home={<Home onSubmit={() => null} />}
    />
  );
}
